// src/services/httpClient.ts
import axios from 'axios';
import { useAuthStore } from '../stores/auth';
import { API_URL } from '../configs/api';
import { useClassStore, useLoadingStore } from '../stores';
import { toast } from 'vue3-toastify';

export const httpClient = axios.create({
    baseURL: API_URL.iclass, // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor to attach the access token to each request
httpClient.interceptors.request.use(
    (config) => {
        // set loading screen
        if (!config.noLoading) {
            const loading = useLoadingStore()
            loading.isLoading = true
        }

        // set access token
        const authStore = useAuthStore();
        const token = authStore.accessToken;
        if (token && !config.skipAuth) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // set system
        const classStore = useClassStore()
        const system = classStore.selectedClassDetails?.system
        if (system) {
            config.headers['X-System'] = system
        }
        
        return config;
    },
    (error) => {
        // set loading screen
        const loading = useLoadingStore()
        loading.isLoading = false

        // notify error
        toast.error(error.message)

        return Promise.reject(error)
    }
)

httpClient.interceptors.response.use(
    (response) => {
        // unset loading screen
        const loading = useLoadingStore()
        loading.isLoading = false

        return response
    },
    (error) => {
        // unset loading screen
        const loading = useLoadingStore()
        loading.isLoading = false

        // notify error
        toast.error(error.message)

        // check authorization
        if (error.response?.status === 401) {
            const authStore = useAuthStore();
            authStore.logout()
        }

        return Promise.reject(error);
    }
)
